import { DatePicker, Divider, Select, Slider } from "antd";
import React, { useState } from "react";

import arrowDown from "../../../assets/icons/arrow-down12.png";
import calendar from "../../../assets/icons/calendar.png";

import dayjs from "dayjs";

export default function AudiencePaymentFilter({ setPaymentFilter, paymentFilter }) {
  const [isArrowDown, setIsArrowDown] = useState(true);

  const paymentMethodOptions = [
    { value: "normal", label: "Normal" },
    { value: "repay", label: "Repay" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
      {/* Payment method & Payment Plan Amount */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
        <div style={{ width: "100%" }}>
          <p style={{ marginBottom: 20, fontSize: 18 }}>Payment Method</p>

          <div style={{ position: "relative" }}>
            <Select
              options={paymentMethodOptions}
              placeholder="Select Payment method"
              value={paymentFilter.payment_method || undefined}
              onChange={(value) => setPaymentFilter((prevData) => ({ ...prevData, payment_method: value }))}
              suffixIcon={<img src={arrowDown} alt="arrow-down" style={{ transform: `rotate(${isArrowDown ? "0" : "180deg"})` }} />}
              className="custom-style-selection"
              style={{ width: "100%", display: "flex", alignItems: "center" }}
              onOpenChange={() => setIsArrowDown((down) => !down)}
            />
          </div>
        </div>

        <Divider type="vertical" style={{ height: 75, backgroundColor: "#B7B7B7", marginInline: 20 }} />

        <div style={{ width: "100%" }}>
          <p style={{ marginBottom: 20, fontSize: 18 }}>Payment Plan Amount Range</p>
          <Slider
            range
            defaultValue={[0, 0]}
            min={0}
            max={10}
            tooltip={{ open: true, placement: "bottom", formatter: (value) => (value === 0 ? value : `${value}K`) }}
            onChange={(value) => setPaymentFilter((prevData) => ({ ...prevData, payment_plan_amount_range: value }))}
          />
        </div>
      </div>

      {/* Payment Plan Create Date */}
      <div>
        <p style={{ marginBottom: 0, fontSize: 18 }}>Payment Plan Created Date</p>
        <p style={{ marginBottom: 10, fontSize: 14, color: "#848696" }}>
          If you just select start date the result will be afterwards and if select end date the result would be before.
        </p>

        <div style={{ display: "flex", alignItems: "center", gap: 10, width: "100%" }}>
          <p style={{ marginBottom: 0, fontSize: 16, color: "#B7B7B7" }}>From</p>
          <DatePicker
            suffixIcon={<img src={calendar} alt="calendar" />}
            name="start_joined_date"
            placeholder="Select Start Date"
            style={{ width: "100%", borderRadius: 10, border: "1px solid #6B43B5", padding: "10px 20px" }}
            value={paymentFilter.creation_start_date ? dayjs(paymentFilter.creation_start_date, "YYYY-MM-DD") : null}
            onChange={(date, dateString) => setPaymentFilter((prevData) => ({ ...prevData, creation_start_date: dateString }))}
          />

          <p style={{ marginBottom: 0, fontSize: 16, color: "#B7B7B7" }}>To</p>
          <DatePicker
            suffixIcon={<img src={calendar} alt="calendar" />}
            name="start_joined_date"
            placeholder="Select End Date"
            style={{ width: "100%", borderRadius: 10, border: "1px solid #6B43B5", padding: "10px 20px" }}
            value={paymentFilter.creation_end_date ? dayjs(paymentFilter.creation_end_date, "YYYY-MM-DD") : null}
            onChange={(date, dateString) => setPaymentFilter((prevData) => ({ ...prevData, creation_end_date: dateString }))}
          />
        </div>
      </div>

      {/* Payment Plan Date Range */}
      <div>
        <p style={{ marginBottom: 0, fontSize: 18 }}>Payment Plan Date Range</p>
        <p style={{ marginBottom: 10, fontSize: 14, color: "#848696" }}>
          If you just select start date the result will be afterwards and if select end date the result would be before.
        </p>

        <div style={{ display: "flex", alignItems: "center", gap: 10, width: "100%" }}>
          <p style={{ marginBottom: 0, fontSize: 16, color: "#B7B7B7" }}>From</p>
          <DatePicker
            suffixIcon={<img src={calendar} alt="calendar" />}
            name="start_joined_date"
            placeholder="Select Start Date"
            style={{ width: "100%", borderRadius: 10, border: "1px solid #6B43B5", padding: "10px 20px" }}
            value={paymentFilter.date_range_start ? dayjs(paymentFilter.date_range_start, "YYYY-MM-DD") : null}
            onChange={(date, dateString) => setPaymentFilter((prevData) => ({ ...prevData, date_range_start: dateString }))}
          />

          <p style={{ marginBottom: 0, fontSize: 16, color: "#B7B7B7" }}>To</p>
          <DatePicker
            suffixIcon={<img src={calendar} alt="calendar" />}
            name="start_joined_date"
            placeholder="Select End Date"
            style={{ width: "100%", borderRadius: 10, border: "1px solid #6B43B5", padding: "10px 20px" }}
            value={paymentFilter.date_range_end ? dayjs(paymentFilter.date_range_end, "YYYY-MM-DD") : null}
            onChange={(date, dateString) => setPaymentFilter((prevData) => ({ ...prevData, date_range_end: dateString }))}
          />
        </div>
      </div>
    </div>
  );
}
